import { makeStyles, Theme } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import style from './styles';
import { IStyleProps } from '../../types/StyleProps';

export const useStyles = makeStyles<Theme, IStyleProps>(style as StyleRules);
